import classNames from 'classnames';

import { ImageFragmentFragment, LinkFragmentFragment } from '../../../__generated__/graphql';
import AppImage from '../../../components/AppImage';
import ButtonLink from '../../../components/Button/ButtonLink';
import { Paragraph } from '../../../components/Text';
import SectionTitle from '../../../layout/Section/SectionTitle';

import style from './card.module.css';

interface CardProps {
  buttonId?: null | string;
  buttonLinkFragment?: LinkFragmentFragment | null;
  description?: null | string;
  id?: null | string;
  image?: ImageFragmentFragment | null;
  pageType: 'page' | 'post';
  title: null | string | undefined;
}

const Card = ({
  buttonId,
  buttonLinkFragment,
  description,
  id,
  image,
  pageType,
  title,
}: CardProps) => {
  return (
    <article
      className={classNames(
        style.baseCard,
        {
          [style.pageCard]: pageType === 'page',
        },
      )}
      id={id ?? undefined}
    >
      {image && (
        <AppImage
          className={style.image}
          fallbackHeight={300}
          fallbackWidth={200}
          image={image}
        />
      )}

      <div className={style.contentContainer}>
        {title && (
          <SectionTitle className={style.title}>
            {title}
          </SectionTitle>
        )}

        {description && (
          <Paragraph fontSize={15}>
            {description}
          </Paragraph>
        )}

        {buttonLinkFragment && (
          <ButtonLink
            buttonColor={pageType === 'post' ? 'white' : 'black'}
            id={buttonId ?? undefined}
            linkFragment={buttonLinkFragment}
          />
        )}
      </div>
    </article>
  );
};

export default Card;
